/** Strip heavy CMS fields from list payloads embedded in SSR HTML. */

export function slimInsightsForShell<T>(items: T[]): T[] {
  return items.map((item) => {
    const copy = { ...item } as Record<string, unknown>;
    delete copy.body;
    delete copy.contentHtml;
    delete copy.craftState;
    delete copy.craftCustomCss;
    delete copy.contentFormat;
    return copy as T;
  });
}

export function slimStoriesForShell<T>(items: T[]): T[] {
  return items.map((item) => {
    const copy = { ...item } as Record<string, unknown>;
    delete copy.body;
    delete copy.craftState;
    delete copy.craftCustomCss;
    delete copy.editorDoc;
    return copy as T;
  });
}

export function slimLeadersForShell<T>(items: T[]): T[] {
  return items.map((item) => {
    const copy = { ...item } as Record<string, unknown>;
    copy.bio = [];
    copy.memberships = [];
    return copy as T;
  });
}
